module.exports = __webpack_public_path__ + "img/pop05.831eda23.jpg";